import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Icon } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
export const PlayerTurnChip = withGame(function PlayerTurnChip({ gameSuite, playerId }) {
    const status = gameSuite.playerStatuses[playerId] ?? null;
    if (gameSuite.gameStatus.status === 'pending') {
        return null;
    }
    const hasPlayed = playerId &&
        gameSuite.viewingRound?.turns.some((turn) => turn.playerId === playerId);
    const isPendingTurn = status?.pendingTurn;
    if (isPendingTurn && !hasPlayed) {
        return (_jsxs(Chip, { emphasis: "primary", className: "@mode-lemon", children: [_jsx(Icon, { name: "clock", size: 16 }), _jsx("span", { children: "Yet to play" })] }));
    }
    if (hasPlayed) {
        return (_jsxs(Chip, { emphasis: "primary", className: "@mode-success", children: [_jsx(Icon, { name: "check", size: 16 }), _jsx("span", { children: "Played" })] }));
    }
    if (!hasPlayed && !isPendingTurn) {
        return (_jsxs(Chip, { emphasis: "default", className: "@mode-neutral", children: [_jsx(Icon, { name: "x", size: 16 }), _jsx("span", { children: "Not playing this round" })] }));
    }
    return null;
});
//# sourceMappingURL=PlayerTurnChip.js.map